import React, { Component } from 'react';
import { Form, Modal, Table } from 'antd';

import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFileTable';

const FormItem = Form.Item;

class ModalAccount extends Component {
  handleOk = () => {
    const { effects } = this.props;
    const newEffects = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        effects.map(item => {
          item.scans = values[`scans${item.uuid}`];
          newEffects.push({
            uuid: item.uuid,
            scans: item.scans,
          });

          if (item.delFiles.length > 0) {
            item.delFiles.map(i => {
              queryDeleteAttachment({
                uuid: i.uuid || i.uid,
              }).then(() => {});
              return i;
            });
          }
          return item;
        });

        this.props.handleOk({ effects: newEffects });
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = (item, file) => {
    item.delFiles.push(file);
  };

  scansColumns = () => {
    const { getFieldDecorator } = this.props.form;
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.uuid}`)(<span>{record.name || '暂无名称'}</span>)}
            </FormItem>
          );
        },
      },
      {
        title: '扫描件',
        dataIndex: 'scans',
        key: 'scans',
        width: '50%',
        render: (text, record) => {
          return (
            <FormItem>
              {getFieldDecorator(`scans${record.uuid}`, {
                rules: [{ required: record.isReturn, message: '请上传扫描件' }],
                initialValue: record.scans,
              })(
                <UploadFile
                  type="ghost"
                  fileList={record.file}
                  onRemove={file => this.fileRemove(record, file)}
                  isPreview
                />,
              )}
            </FormItem>
          );
        },
      },
    ];
  };

  render() {
    const { visible, handleCancel, effects, confirmLoading } = this.props;
    return (
      <Modal
        title="上传扫描件（用章后）"
        visible={visible}
        onOk={this.handleOk}
        okText="通过"
        confirmLoading={confirmLoading}
        onCancel={() => handleCancel(false)}
        width="40%"
      >
        <Form>
          <Table
            columns={this.scansColumns()}
            dataSource={effects}
            pagination={false}
            rowKey={record => record.uuid}
          />
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/seal/ModalScanUpload.js